import { updateObject } from "../../shared/utility";
import { dashboardConstants, globalConstants } from "../../constants";

//-------InitialState of the device reducer
const initialState = {
  atAGlance: "",
  storeTransactionHistory: [],
  displayOutletToast: true,
  displayOutletToastInitialCheck: false,
};

//-------Export Device Reducer
export const dashboard = (state = initialState, action) => {
  switch (action.type) {
    //-------Get all devices success case
    case dashboardConstants.GET_AT_A_GLANCE + globalConstants.SUCCESS:
      return updateObject(state, {
        atAGlance: action.data,
      });

    //-------Get all devices success case
    case dashboardConstants.GET_STORE_HISTORY + globalConstants.SUCCESS:
      return updateObject(state, {
        storeTransactionHistory: action.data,
      });

    //-------display toast case
    case dashboardConstants.DISPLAY_OUTLET_TOAST + globalConstants.SUCCESS:
      return updateObject(state, {
        displayOutletToast: false,
      });
    case dashboardConstants.DISPLAY_OUTLET_TOAST_INITIAL_CHECK +
      globalConstants.SUCCESS:
      return updateObject(state, {
        displayOutletToastInitialCheck: true,
      });
    //-------Default State
    default:
      return state;
  }
};
